import { fetchData, PaginationParameters, PaginationResponse } from "@request";
import { getQueryParams } from "@request/helpers";

export type AdminOrder = {
  created_at: string;
  created_at_unix: number;
  currency: string;
  exchange_rate: number;
  id: string;
  invid: string;
  merchant_amount: number;
  merchant_amount_usdt: number;
  merchant_ern_usdt: number;
  merchant_id: string;
  merchant_login: string;
  mesasge: string;
  method: string;
  order_final_amount: number;
  order_final_amount_usdt: number;
  order_start_amount: number;
  order_start_amount_usdt: number;
  our_ern_usdt: number;
  requisite: string;
  status: string;
  trader_email: string;
  trader_ern_usdt: number;
  trader_id: string;
};

export type AdminOrdersResponse = PaginationResponse<{
  orders: AdminOrder[];
}>;

export enum AdminOrderStatus {
  PENDING = "pending",
  PROCESSING = "processing",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
}

export enum AdminOrderType {
  PAY_IN = "pay_in",
  PAY_OUT = "pay_out",
}

export type AdminOrdersRequest = PaginationParameters<{
  status?: AdminOrderStatus;
  type?: AdminOrderType;
  trader_id?: string;
  merchant_id?: string;
  platform?: boolean;
}>;

export const getAdminOrdersApi = async (data?: AdminOrdersRequest) => {
  try {
    const queryParams = getQueryParams(data);
    const response = await fetchData<AdminOrdersResponse>({
      url: `api/v1/admin/orders?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("getAdminOrdersApi failed:", error);
    throw error;
  }
};
